import { render, staticRenderFns } from "./404.vue?vue&type=template&id=2fe7c58b"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=2fe7c58b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports